var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "h3",
        {
          staticClass: "title",
          attrs: { content: "edit", placement: "bottom" }
        },
        [
          _vm._v("\n    Client Management\n    "),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticStyle: { width: "180px", "margin-right": "10px" },
              on: { click: _vm.handleExport }
            },
            [_vm._v("Export")]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "search-toggle",
              on: {
                click: function($event) {
                  _vm.searchExpanded = !_vm.searchExpanded
                }
              }
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.searchExpanded ? "Hide Filters" : "Show Filters") +
                  "\n      "
              ),
              _c("em", {
                staticClass: "el-icon-arrow-up",
                class: { "is-collapsed": !_vm.searchExpanded }
              })
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.searchExpanded,
              expression: "searchExpanded"
            }
          ],
          staticClass: "searchBox"
        },
        [
          _c(
            "el-form",
            {
              ref: "formInline",
              staticClass: "demo-form-inline",
              attrs: { model: _vm.formInline }
            },
            [
              _c(
                "div",
                { staticClass: "search-grid" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "clientID" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "Client ID", maxlength: "50" },
                        nativeOn: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.submitSearch.apply(null, arguments)
                          }
                        },
                        model: {
                          value: _vm.formInline.clientID,
                          callback: function($$v) {
                            _vm.$set(_vm.formInline, "clientID", $$v)
                          },
                          expression: "formInline.clientID"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "lastName" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "Last Name", maxlength: "50" },
                        nativeOn: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.submitSearch.apply(null, arguments)
                          }
                        },
                        model: {
                          value: _vm.formInline.lastName,
                          callback: function($$v) {
                            _vm.$set(_vm.formInline, "lastName", $$v)
                          },
                          expression: "formInline.lastName"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "firstName" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "First Name", maxlength: "50" },
                        nativeOn: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.submitSearch.apply(null, arguments)
                          }
                        },
                        model: {
                          value: _vm.formInline.firstName,
                          callback: function($$v) {
                            _vm.$set(_vm.formInline, "firstName", $$v)
                          },
                          expression: "formInline.firstName"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "userName" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "User Name", maxlength: "50" },
                        nativeOn: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.submitSearch.apply(null, arguments)
                          }
                        },
                        model: {
                          value: _vm.formInline.userName,
                          callback: function($$v) {
                            _vm.$set(_vm.formInline, "userName", $$v)
                          },
                          expression: "formInline.userName"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "email" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "Email", maxlength: "50" },
                        nativeOn: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.submitSearch.apply(null, arguments)
                          }
                        },
                        model: {
                          value: _vm.formInline.email,
                          callback: function($$v) {
                            _vm.$set(_vm.formInline, "email", $$v)
                          },
                          expression: "formInline.email"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "cellularphone" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "Mobile Phone", maxlength: "50" },
                        on: { input: _vm.handleInput },
                        nativeOn: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.submitSearch.apply(null, arguments)
                          }
                        },
                        model: {
                          value: _vm.formInline.cellularphone,
                          callback: function($$v) {
                            _vm.$set(_vm.formInline, "cellularphone", $$v)
                          },
                          expression: "formInline.cellularphone"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "salseforceServicingChannelName" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "Referral Company",
                          maxlength: "50"
                        },
                        nativeOn: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.submitSearch.apply(null, arguments)
                          }
                        },
                        model: {
                          value: _vm.formInline.salseforceServicingChannelName,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.formInline,
                              "salseforceServicingChannelName",
                              $$v
                            )
                          },
                          expression:
                            "formInline.salseforceServicingChannelName"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "salseforceServicingFinancialPlanner" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "Referral Planner",
                          maxlength: "50"
                        },
                        nativeOn: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.submitSearch.apply(null, arguments)
                          }
                        },
                        model: {
                          value:
                            _vm.formInline.salseforceServicingFinancialPlanner,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.formInline,
                              "salseforceServicingFinancialPlanner",
                              $$v
                            )
                          },
                          expression:
                            "formInline.salseforceServicingFinancialPlanner"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "salseforceReferredByIfa" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "Sub-referral Company",
                          maxlength: "50"
                        },
                        nativeOn: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.submitSearch.apply(null, arguments)
                          }
                        },
                        model: {
                          value: _vm.formInline.salseforceReferredByIfa,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.formInline,
                              "salseforceReferredByIfa",
                              $$v
                            )
                          },
                          expression: "formInline.salseforceReferredByIfa"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "salseforceReferredByPlanner" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "Sub-referral Planner",
                          maxlength: "50"
                        },
                        nativeOn: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.submitSearch.apply(null, arguments)
                          }
                        },
                        model: {
                          value: _vm.formInline.salseforceReferredByPlanner,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.formInline,
                              "salseforceReferredByPlanner",
                              $$v
                            )
                          },
                          expression: "formInline.salseforceReferredByPlanner"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "representative" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "Account Manager",
                          maxlength: "50"
                        },
                        nativeOn: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.submitSearch.apply(null, arguments)
                          }
                        },
                        model: {
                          value: _vm.formInline.representative,
                          callback: function($$v) {
                            _vm.$set(_vm.formInline, "representative", $$v)
                          },
                          expression: "formInline.representative"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "search-toolbar" }, [
            _c(
              "div",
              { staticClass: "search-toolbar__actions" },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "search",
                    attrs: { type: "primary" },
                    on: { click: _vm.submitSearch }
                  },
                  [_vm._v("Search")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticClass: "reset",
                    on: {
                      click: function($event) {
                        return _vm.resetForm("formInline")
                      }
                    }
                  },
                  [_vm._v("Reset")]
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "client-panel" },
        [
          _c("div", { staticClass: "client-panel__toolbar" }, [
            _c(
              "div",
              { staticClass: "search-toolbar__extra" },
              [
                _c("columns-control", {
                  attrs: {
                    columns: _vm.columnsConfig,
                    "storage-key": "cms.clientManagement.columns"
                  },
                  on: { change: _vm.onColumnsChange }
                }),
                _vm._v(" "),
                _c(
                  "el-dropdown",
                  { ref: "filter", attrs: { trigger: "click" } },
                  [
                    _c("span", { staticClass: "el-dropdown-link sortbox" }, [
                      _c("em", { staticClass: "filter" }),
                      _vm._v("\n            Filter\n          ")
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-dropdown-menu",
                      { attrs: { slot: "dropdown" }, slot: "dropdown" },
                      [
                        _c(
                          "el-form",
                          {
                            ref: "formFilter",
                            staticStyle: {
                              width: "300px",
                              padding: "14px 24px"
                            },
                            attrs: { model: _vm.formFilter }
                          },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { "margin-bottom": "12px" },
                                attrs: {
                                  label: "Sales Office",
                                  prop: "salesOffice"
                                }
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      "popper-append-to-body": false,
                                      disabled: _vm.$store.state.userLevel >= 2
                                    },
                                    on: { change: _vm.changeSalesOffice },
                                    model: {
                                      value: _vm.formFilter.salesOffice,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFilter,
                                          "salesOffice",
                                          $$v
                                        )
                                      },
                                      expression: "formFilter.salesOffice"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-option",
                                      { attrs: { value: "All" } },
                                      [_vm._v("All")]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(_vm.salesOfficeList, function(
                                      item,
                                      index
                                    ) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.name,
                                          value: item.code
                                        }
                                      })
                                    })
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { "margin-bottom": "12px" },
                                attrs: { label: "Region", prop: "region" }
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: { "popper-append-to-body": false },
                                    model: {
                                      value: _vm.formFilter.region,
                                      callback: function($$v) {
                                        _vm.$set(_vm.formFilter, "region", $$v)
                                      },
                                      expression: "formFilter.region"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-option",
                                      { attrs: { value: "All" } },
                                      [_vm._v("All")]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(_vm.regionList, function(
                                      item,
                                      index
                                    ) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.name,
                                          value: item.code
                                        }
                                      })
                                    })
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { "margin-bottom": "12px" },
                                attrs: { label: "User Status", prop: "status" }
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: { "popper-append-to-body": false },
                                    model: {
                                      value: _vm.formFilter.status,
                                      callback: function($$v) {
                                        _vm.$set(_vm.formFilter, "status", $$v)
                                      },
                                      expression: "formFilter.status"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-option",
                                      { attrs: { value: "All" } },
                                      [_vm._v("All")]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(_vm.userStatusList, function(
                                      item,
                                      index
                                    ) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.name,
                                          value: item.code
                                        }
                                      })
                                    })
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { "margin-bottom": "12px" },
                                attrs: {
                                  label: "Account Manager",
                                  prop: "type"
                                }
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: { "popper-append-to-body": false },
                                    model: {
                                      value: _vm.formFilter.type,
                                      callback: function($$v) {
                                        _vm.$set(_vm.formFilter, "type", $$v)
                                      },
                                      expression: "formFilter.type"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-option",
                                      { attrs: { value: "All" } },
                                      [_vm._v("All")]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(_vm.userTypeList, function(
                                      item,
                                      index
                                    ) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.name,
                                          value: item.code
                                        }
                                      })
                                    })
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "filterButton" },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: {
                                      "margin-right": "15px",
                                      "margin-bottom": "0"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "reset",
                                        on: {
                                          click: function($event) {
                                            _vm.$refs.filter.hide()
                                            _vm.resetForm("formFilter")
                                          }
                                        }
                                      },
                                      [_vm._v("Reset")]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { staticStyle: { "margin-bottom": "0" } },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "search",
                                        attrs: { type: "primary" },
                                        on: {
                                          click: function() {
                                            _vm.$refs.filter.hide()
                                            _vm.submitSearch()
                                          }
                                        }
                                      },
                                      [_vm._v("Apply")]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-dropdown",
                  {
                    attrs: { trigger: "click" },
                    on: { command: _vm.handleCommand }
                  },
                  [
                    _c("span", { staticClass: "el-dropdown-link sortbox" }, [
                      _c("em", { staticClass: "sort" }),
                      _vm._v("\n            Sort by\n          ")
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-dropdown-menu",
                      { attrs: { slot: "dropdown" }, slot: "dropdown" },
                      [
                        _c(
                          "el-dropdown-item",
                          {
                            attrs: { command: ["lastLoginAt,desc", "id,asc"] }
                          },
                          [_vm._v("Last login date (New - Old)")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-dropdown-item",
                          { attrs: { command: ["lastLoginAt,asc", "id,asc"] } },
                          [_vm._v("Last login date (Old - New)")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-dropdown-item",
                          {
                            attrs: { command: ["cmsUpdatedAt,desc", "id,asc"] }
                          },
                          [_vm._v("Last update date (New - Old)")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-dropdown-item",
                          {
                            attrs: { command: ["cmsUpdatedAt,asc", "id,asc"] }
                          },
                          [_vm._v("Last update date (Old - New)")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-dropdown-item",
                          {
                            attrs: { command: ["activationAt,desc", "id,asc"] }
                          },
                          [_vm._v("Activation Date (New - Old)")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-dropdown-item",
                          {
                            attrs: { command: ["activationAt,asc", "id,asc"] }
                          },
                          [_vm._v("Activation Date (Old - New)")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _vm.tagList.length
            ? _c(
                "div",
                { staticClass: "client-panel__tags" },
                _vm._l(_vm.tagList, function(tag) {
                  return _c(
                    "el-tag",
                    {
                      key: tag.code,
                      staticStyle: { margin: "0 5px" },
                      attrs: {
                        closable: "",
                        type: "info",
                        "disable-transitions": false
                      },
                      on: {
                        close: function($event) {
                          return _vm.handleClose(tag)
                        }
                      }
                    },
                    [_vm._v("\n      " + _vm._s(tag.tag) + "\n    ")]
                  )
                }),
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-table",
            { attrs: { data: _vm.tableData } },
            [
              _vm.isColumnVisible("clientID")
                ? _c("el-table-column", {
                    attrs: { prop: "clientID", label: "Client ID" }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isColumnVisible("salesOffice")
                ? _c("el-table-column", {
                    attrs: { label: "Sales Office" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                _vm._s(
                                  _vm.$commonjs.salesOfficeMap(
                                    scope.row.salesOffice
                                  )
                                )
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      4066695550
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isColumnVisible("region")
                ? _c("el-table-column", {
                    attrs: { label: "Region" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                _vm._s(
                                  _vm.$commonjs.regionMap(scope.row.region)
                                )
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3697618558
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isColumnVisible("fullName")
                ? _c("el-table-column", {
                    attrs: {
                      label: "Full Name",
                      "show-overflow-tooltip": true
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                "\n        " +
                                  _vm._s(
                                    scope.row.firstName
                                      ? scope.row.lastName +
                                          ", " +
                                          scope.row.firstName +
                                          (scope.row.middleName
                                            ? " " + scope.row.middleName
                                            : "")
                                      : scope.row.lastName +
                                          (scope.row.middleName
                                            ? " " + scope.row.middleName
                                            : "")
                                  ) +
                                  "\n      "
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3174421268
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isColumnVisible("username")
                ? _c("el-table-column", {
                    attrs: {
                      prop: "username",
                      label: "Username",
                      "show-overflow-tooltip": true
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isColumnVisible("salesforceEmail")
                ? _c("el-table-column", {
                    attrs: {
                      prop: "salesforceEmail",
                      label: "Email",
                      "show-overflow-tooltip": true
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isColumnVisible("cellularphone")
                ? _c("el-table-column", {
                    attrs: { prop: "cellularphone", label: "Mobile Phone" }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isColumnVisible("dob")
                ? _c("el-table-column", {
                    attrs: {
                      prop: "dob",
                      label: "Date of birth",
                      formatter: _vm.$commonjs.tableFormatDate
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isColumnVisible("lastLoginAt")
                ? _c("el-table-column", {
                    attrs: {
                      prop: "lastLoginAt",
                      label: "Last login",
                      formatter: _vm.$commonjs.tableFormatDateTime
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isColumnVisible("activationAt")
                ? _c("el-table-column", {
                    attrs: {
                      prop: "activationAt",
                      label: "Activation Date",
                      formatter: _vm.$commonjs.tableFormatDateTime
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isColumnVisible("status")
                ? _c("el-table-column", {
                    attrs: { label: "Status" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "span",
                                { class: "userstatus-" + scope.row.userStatus },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(
                                        _vm.$commonjs.userStatusMap(
                                          scope.row.userStatus
                                        )
                                      ) +
                                      "\n        "
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2905459837
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isColumnVisible("representative")
                ? _c("el-table-column", {
                    attrs: {
                      prop: "representative",
                      label: "Account Manager",
                      "show-overflow-tooltip": true
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isColumnVisible("salseforceServicingChannelName")
                ? _c("el-table-column", {
                    attrs: {
                      prop: "salseforceServicingChannelName",
                      label: "Referral Company",
                      "show-overflow-tooltip": true
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isColumnVisible("salseforceServicingFinancialPlanner")
                ? _c("el-table-column", {
                    attrs: {
                      prop: "salseforceServicingFinancialPlanner",
                      label: "Referral Planner",
                      "show-overflow-tooltip": true
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isColumnVisible("salseforceReferredByIfa")
                ? _c("el-table-column", {
                    attrs: {
                      prop: "salseforceReferredByIfa",
                      label: "Sub-referral Company",
                      "show-overflow-tooltip": true
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isColumnVisible("salseforceReferredByPlanner")
                ? _c("el-table-column", {
                    attrs: {
                      prop: "salseforceReferredByPlanner",
                      label: "Sub-referral Planner",
                      "show-overflow-tooltip": true
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isColumnVisible("cmsUpdatedAt")
                ? _c("el-table-column", {
                    attrs: {
                      prop: "cmsUpdatedAt",
                      label: "Last update",
                      formatter: _vm.$commonjs.tableFormatDateTime
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Operation" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content: "Edit",
                              placement: "top"
                            }
                          },
                          [
                            _c("em", {
                              staticClass: "edit",
                              staticStyle: { "margin-right": "10px" },
                              on: {
                                click: function($event) {
                                  return _vm.handleEdit(scope.row)
                                }
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _vm.showSave
                          ? _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: {
                                  effect: "dark",
                                  content: "More",
                                  placement: "top"
                                }
                              },
                              [
                                scope.row.userStatus != "OPENED"
                                  ? _c(
                                      "el-dropdown",
                                      {
                                        attrs: { trigger: "click" },
                                        on: {
                                          command: function(command) {
                                            return _vm.handleMore(
                                              command,
                                              scope.row
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "el-dropdown-link sortbox"
                                          },
                                          [_c("em", { staticClass: "more" })]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-dropdown-menu",
                                          {
                                            attrs: { slot: "dropdown" },
                                            slot: "dropdown"
                                          },
                                          [
                                            scope.row.userStatus != "OPENED"
                                              ? _c(
                                                  "el-dropdown-item",
                                                  {
                                                    attrs: {
                                                      command: "emailUserName"
                                                    }
                                                  },
                                                  [_vm._v("Email Username")]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            scope.row.userStatus != "OPENED"
                                              ? _c(
                                                  "el-dropdown-item",
                                                  {
                                                    attrs: {
                                                      command: "restPassword"
                                                    }
                                                  },
                                                  [_vm._v("Reset password")]
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("app-pagination", {
            attrs: {
              "current-page": _vm.currentPage,
              "page-sizes": [5, 10, 20, 50],
              total: _vm.total,
              "page-size": _vm.currentSize
            },
            on: {
              "size-change": function(v) {
                _vm.currentSize = v
                _vm.currentPage = 1
                _vm.getList()
              },
              "current-change": function(v) {
                _vm.currentPage = v
                _vm.getList()
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.demandDialog,
            width: "420px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.demandDialog = $event
            },
            close: function($event) {
              return _vm.$refs.formDemand.resetFields()
            }
          }
        },
        [
          _c(
            "h3",
            {
              staticClass: "demandDialogTitle",
              attrs: { slot: "title" },
              slot: "title"
            },
            [
              _vm._v(
                "\n      Starting from the following dates, get all updated/created customers\n      from Salesforce:\n    "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "formDemand",
              staticClass: "formDemand",
              attrs: { model: _vm.formDemand, rules: _vm.formDemandRules }
            },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "dateTime" } },
                [
                  _c(
                    "el-row",
                    {
                      staticStyle: { "margin-bottom": "0" },
                      attrs: {
                        gutter: 10,
                        justify: "space-between",
                        type: "flex"
                      }
                    },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "date", label: "Start Date" } },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  type: "date",
                                  "range-separator": "/",
                                  format: "yyyy-MM-dd",
                                  "value-format": "yyyy-MM-dd",
                                  placeholder: "Date"
                                },
                                on: { change: _vm.handledateTime },
                                model: {
                                  value: _vm.formDemand.date,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formDemand, "date", $$v)
                                  },
                                  expression: "formDemand.date"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "time", label: "Start Time" } },
                            [
                              _c("el-time-select", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "picker-options": {
                                    start: "00:00",
                                    step: "00:15",
                                    end: "24:00"
                                  },
                                  placeholder: "Time"
                                },
                                on: { change: _vm.handledateTime },
                                model: {
                                  value: _vm.formDemand.time,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formDemand, "time", $$v)
                                  },
                                  expression: "formDemand.time"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              staticStyle: { "margin-top": "-30px" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.demandDialog = false
                    }
                  }
                },
                [_vm._v("Cancel")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleRunDemand }
                },
                [_vm._v("Confirm")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7cfd3f9e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cfd3f9e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/appUser/User.vue
// module id = null
// module chunks = 